import { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Fade, IconButton, Typography, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { SummaryList, SidePanelLayout } from '@lendica/components';
import { useContainerWidth } from '@lendica/hooks';
import { Deal } from '@lendica/utils';
import { mapDealToSummary } from '../utils/helpers';
import { useWalletApi } from '../walletAPI';

const convertToCSV = (deal: Deal | undefined) => {
    const escapeCsv = (input: unknown) => {
        const str = input == null ? '' : String(input);
        return '"' + str.replace(/"/g, '""') + '"';
    };

    const dealSummary = mapDealToSummary(deal);

    const headersLine = dealSummary.map(item => escapeCsv(item.label)).join(',');
    const valuesLine = dealSummary.map(item => escapeCsv((item as any).value)).join(',');
    const csvContent = headersLine + '\r\n' + valuesLine;

    const encodedUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `Lendica_Deal_Summary_${deal!.id}.csv`);
    document.body.appendChild(link);

    link.click();
};

export const DealSummaryView: FC = () => {
    const { isNarrow } = useContainerWidth();
    const { dealId } = useParams();
    // const deal = useMemo(() => data?.deals?.find(deal => deal.id === dealId), [data, dealId]);
    const [visualCue, setVisualCue] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [deal, setDeal] = useState({});
    const { getDealDetails } = useWalletApi();

    useEffect(() => {
        const getDeal = async () => {
            const dealInfo = await getDealDetails(dealId!);
            setDeal(dealInfo);
            setIsLoading(false);
        };
        getDeal();
    }, [dealId]);

    useEffect(() => {
        setVisualCue(true);
        setTimeout(() => setVisualCue(false), 200);
    }, [dealId]);

    return (
        <SidePanelLayout loading={isLoading || visualCue} redirectRoute="/wallet">
            <Fade in={!visualCue}>
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        overflow: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: 600,
                            height: '100%',
                            width: '100%',
                            // bgcolor: 'background.default',
                        }}
                    >
                        <SummaryList
                            title={
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        bgcolor: isNarrow ? 'background.default' : 'transparent',
                                    }}
                                >
                                    <Typography variant="subtitle1">Deal Summary</Typography>
                                    <Tooltip title="Download as CSV">
                                        <IconButton
                                            color="secondary"
                                            aria-label="download report"
                                            size="small"
                                            onClick={() => convertToCSV(deal as Deal)}
                                        >
                                            <DownloadIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            }
                            data={mapDealToSummary(deal as Deal)}
                        />
                        <Box pb={6} />
                    </Box>
                </Box>
            </Fade>
        </SidePanelLayout>
    );
};
